import React, { useEffect, useState, useCallback } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import { FaEye } from 'react-icons/fa';
import ClaimDocuments from '../components/RaiseClaim/ClaimDocuments';
import InfoRaiseClaimModal from '../components/RaiseClaim/InfoRaiseClaimModal';
import { Link, useLocation } from 'react-router-dom';
import RaiseClaimModal from '../components/RaiseClaim/RaiseClaimModal';
import ClaimSettlement from '../components/RaiseClaim/ClaimSettlement';
import { commonService, raiseClaimService } from '../services';
import Loading from '../components/common/Loading';
import RaisePerformanceOverview from './RaisePerformanceOverview';

const RaiseClaimSummary = () => {
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [isAddEditModalOpen, setIsAddEditModalOpen] = useState(false)
    const [activeTab, setActiveTab] = useState('1');
    const [claimDetails, setClaimDetails] = useState({});
    const [isSpotSurvey, setIsSpotSurvey] = useState(false);

    const toggleTab = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const { FYList, policyTypeList, policySubTypeList, divisionDropdownList, raiseClaimId } = location?.state || {};

    const openAddEditModal = () => {
        setIsAddEditModalOpen(true);
    }
    const closeAddEditModal = () => {
        setIsAddEditModalOpen(false)
    }


    const fetchClaimTemplateDetails = useCallback(async (raiseClaimId) => {
        if (raiseClaimId) {
            setIsLoading(true);
            const claimTemplateDetailsResponse = await raiseClaimService.raiseClaimDetails({ claimRaiseId: raiseClaimId });
            if (claimTemplateDetailsResponse?.isSuccess) {
                setClaimDetails(claimTemplateDetailsResponse?.data);
                setIsLoading(false);
                return claimTemplateDetailsResponse?.data;
            }
            setIsLoading(false);
        }
    }, []);


    const fetchCommonDropdownList = useCallback(async () => {
        setIsLoading(true)
        const commonResponse = await commonService.dropdown({ moduleName: "Cause-Of-Loss", id: 0, purpose: "" });
        setIsLoading(false)
        if (commonResponse?.data?.isSuccess) {
            return commonResponse?.data?.data
        }
        return false
    }, []);

    function getApprovedAmount() {
        if (claimDetails?.surveyorAssesmentAmount) {
            return claimDetails?.surveyorAssesmentAmount;
        } 
        // else if (claimDetails?.estimatedLossReserve) {
        //     return claimDetails?.estimatedLossReserve;
        // }
        else {
            return "NA";
        }
    }

    useEffect(() => {
        const fetchList = async () => {
            let detailedClaim = await fetchClaimTemplateDetails(raiseClaimId)
            let causeLoss = await fetchCommonDropdownList()
            if (detailedClaim?.raiseClaimId) {
                let isSpotSurveys = ["Accident", "Wet"].some(keyword =>
                    causeLoss?.find((cause) => cause.id === +detailedClaim?.majorCauseOfLossId)?.name
                        ?.includes(keyword)
                )
                setIsSpotSurvey(isSpotSurveys)
            }
        }
        fetchList()
    }, [])

    return (
        !isLoading ?
            <div className='mt-4'>
                <div className='fieldArrayColumnUl_outer'>
                    <div className='fieldArrayColumnUl_Head' >
                        <button className="left d-flex bg-transparent border-0"
                        >
                            <Link to="/external/raise-claim" >
                                <i className="bx bxs-left-arrow-alt me-2" />
                            </Link>
                            <h5>Claim Summary</h5>
                        </button>
                        {/* <h5>Claim Summary</h5> */}
                        <FaEye size={20} style={{ cursor: "pointer" }}
                            onClick={() =>
                                openAddEditModal()
                            }
                        />
                    </div>
                    <ul className='fieldArrayColumnUl'>
                        <li className='mb-2'><span className=''>Corporate Claim Number :</span>  {claimDetails?.corPorateNo || "NA"}</li>
                        <li className='mb-2'><span className=''>Insurance Claim No. : </span> {claimDetails?.insurerClaimNo || "NA"}</li>
                        <li className='mb-2'><span className=''>Surveyor Claim No. : </span> {claimDetails?.surveyorClaimNo || "NA"}</li>
                        <li className='mb-2'><span className=''>Policy Name :</span> {claimDetails?.policyName || "NA"}</li>
                        <li className='mb-2'><span className=''>Division :</span> {claimDetails?.division || "NA"}</li>
                        <li className='mb-2'><span className=''>Financial Year : </span>{claimDetails?.finYear || "NA"}</li>
                        <li className='mb-2'><span className=''>Claim Intimation Date : </span>{claimDetails?.claimIntimationDate || "NA"}</li>
                        <li className='mb-2'><span className=''>Estimated Loss Amount : </span>{claimDetails?.estimatedLoss || "NA"}</li>
                        <li className='mb-2'><span className=''>Insurance Company : </span> {claimDetails?.insuranceCompany || "NA"}</li>
                        <li className='mb-2'><span className=''>Surveyor Company : </span> {claimDetails?.surveyorCompany || "NA"}</li>
                        {/* <li className='mb-2'><span className=''>Surveyor Name : </span> {claimDetails?.surveyorAppointmentStatus === "Default Surveyor" ? "ALL" : claimDetails?.surveyorName ? claimDetails?.surveyorName : "NA"}</li> */}
                        <li className='mb-2'><span className=''>Approved Amount : </span> {getApprovedAmount()}</li>
                        <li className='mb-2'><span className=''>Claim Status : </span> {claimDetails?.claimStatus || "NA"}</li>
                        <li className='mb-2'><span className=''>Current Status : </span> {claimDetails?.currentStatus || "NA"}</li>
                        <li className='mb-2'><span className=''>Claim Withdrawn Reason : </span> {claimDetails?.claimWithdrawnReason || "NA"}</li>
                        <li className='mb-2'><span className=''>Investigator Name : </span> {claimDetails?.investigatorName || "NA"}</li>
                        <li className='mb-2'><span className=''>Investigator Email Id : </span> {claimDetails?.investigatorEmailId || "NA"}</li>
                        <li className='mb-2'><span className=''>Investigator Contact No. : </span> {claimDetails?.investigatorContactNo || "NA"}</li>
                        <li className='mb-2'></li>
                        {isSpotSurvey &&
                            <li className='mb-2'><p style={{ color: "red", fontWeight: "bold", fontSize: "1.1rem" }}>Spot Survey</p></li>
                        }

                    </ul>
                </div>
                <div className='mt-4 fieldArrayColumnUl_outer'>
                    <Nav tabs style={{ marginBottom: "40px", cursor: "pointer" }}>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '1' })}
                                onClick={() => { toggleTab('1'); }}
                            >
                                Claim Documents
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '2' })}
                                onClick={() => { toggleTab('2'); }}
                            >
                                Claim Settlement
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '3' })}
                                onClick={() => { toggleTab('3'); }}
                            >
                                External Communication
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '4' })}
                                onClick={() => { toggleTab('4'); }}
                            >
                                Claim Performance Overview
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            {activeTab === "1" && <ClaimDocuments claimId={raiseClaimId} fetchClaimTemplateDetails={fetchClaimTemplateDetails} detailedClaim={claimDetails} />}
                        </TabPane>
                        <TabPane tabId="2">
                            {activeTab === "2" && <ClaimSettlement claimDetails={claimDetails} fetchClaimTemplateDetails={fetchClaimTemplateDetails} raiseClaimId={raiseClaimId} />}
                        </TabPane>
                        <TabPane tabId="3">
                            {activeTab === "3" && <InfoRaiseClaimModal raiseClaimId={raiseClaimId} claimDetails={claimDetails} />}
                        </TabPane>
                        <TabPane tabId="4">
                            {activeTab === "4" && <RaisePerformanceOverview claimId={raiseClaimId} />}
                        </TabPane>
                    </TabContent>

                </div>
                {
                    isAddEditModalOpen ? (
                        <RaiseClaimModal
                            fetchRaiseClaimList={""}
                            FYList={FYList}
                            policyTypeList={policyTypeList}
                            policySubTypeList={policySubTypeList}
                            divisionDropdownList={divisionDropdownList}
                            action={{ type: "View", claimDetails: claimDetails, policyTypeId: claimDetails?.policyTypeId }}
                            closeModal={closeAddEditModal}
                            isOpen={isAddEditModalOpen}
                        />
                    ) : null
                }
            </div> : <Loading />
    )
}
export default RaiseClaimSummary

